import { DependenciesInjection } from "app/di/DependencyInjection";
import { ErrorCodeGeneralImpl } from "../data/ErrorCodeGeneralImpl";
import { IErrorCodeGeneralRepository } from "../domain/repositories/IErrorCodeGeneralRepository";
import { ErrorCodeGeneralUseCase } from "../domain/useCases/ErrorCodeGeneralUseCase";
import { ErrorCodeGeneralViewModel } from "../presentation/viewModel/ErrorCodeGeneralViewModel";
import { ErrorCodeGeneralToken } from "./ErrorCodeGeneralToken";

export class ErrorCodeGeneralInjection {
  static initInjection() {
    DependenciesInjection.register<IErrorCodeGeneralRepository>(
      ErrorCodeGeneralToken.IErrorCodeGeneralRepository,
      ErrorCodeGeneralImpl,
      "otherRepo",
    );
    DependenciesInjection.register<ErrorCodeGeneralUseCase>(
      ErrorCodeGeneralToken.ErrorCodeGeneralUseCase,
      ErrorCodeGeneralUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<ErrorCodeGeneralViewModel>(
      ErrorCodeGeneralToken.ErrorCodeGeneralViewModel,
      ErrorCodeGeneralViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IErrorCodeGeneralRepository>(
      ErrorCodeGeneralToken.IErrorCodeGeneralRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<ErrorCodeGeneralUseCase>(
      ErrorCodeGeneralToken.ErrorCodeGeneralUseCase,
    );
  }
}
